import React, { useEffect, useState } from 'react'
import ActivityBasicInfo from './BasicInformationTab/ActivityBasicInfo';
import ActivityVariants from './ActivityTab/ActivityVariants';
import ActivityPricing from './PricingTab/ActivityPricing';
import { useDispatch } from 'react-redux';
import { ClearLocalStorage } from '../../commonClass/Session';
import { getAllData, verifytoken } from '../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../_actions/loader.actions';
import { useLocation, useNavigate } from 'react-router-dom';
import { getactivitymanagebyid } from '../ActivitymasterUtility';
import { decrpt } from '../../commonClass//enc_dec/enc_dec';
import ActivityInventory from './InventoryTab/ActivityInventory';

export const getActivityManageId = () => {
    const encryptedData = localStorage.getItem("ami");
    if (!encryptedData) return null;
    try {
        return decrpt(encryptedData);
    } catch (error) {
        console.error("Failed to decrypt AMI data", error);
        return null;
    }
};

const ManageActivityMaster = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [selectTab, setSelectTab] = useState(1);
    const [editDisabled, setEditDisabled] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [dropdownData, setDropdownData] = useState({
        supplierList: [],
        collectionWiseCategory: [],
        activityList: [],
        stateList: [],
        cityList: [],
        accessPointOtherList: [],
        pickupPointList: [],
        dropPointList: [],
        weekDayList: [],
        policyTypeList: [],
        paxTypeList: [],
        taxList: [],
        currentStatusList: [],
    });

    const [ActivityBasicInfoId, setActivityBasicInfoId] = useState(0);
    const [ActivityManagePricingId, setActivityManagePricingId] = useState(0);
    const [ActivityName, setActivityName] = useState("");
    const [basicInfoTab, setBasicInfoTab] = useState(null);
    const [activityInfo, setActivityInfo] = useState({})
    const [PricingTab, setPricingTab] = useState(null);

    //#region API calling functions

    //#region call retrieve API
    const setRetrieveData = async (ActivityManageId, cityList, activityList = []) => {
        if (ActivityManageId > 0) {
            const retrieveData = await getactivitymanagebyid(ActivityManageId, cityList);
            const activityId = retrieveData?.BasicInformationForm?.ActivityId || 0;
            const activityName = activityList?.find((prev) => prev?.value === activityId)?.label || "";

            setActivityBasicInfoId(retrieveData?.BasicInformationForm?.ActivityBasicInfoId);
            setActivityName(activityName);

            setBasicInfoTab(retrieveData);
            setActivityInfo({
                ...activityInfo,
                activityInfo: {
                    ...retrieveData?.activityInfo,
                    activityBasicInfoId: retrieveData?.BasicInformationForm?.ActivityBasicInfoId
                },
                activityInfoInclusion: retrieveData?.activityInfoInclusion
            });
            setPricingTab(retrieveData?.PricingTab)
            setActivityManagePricingId(retrieveData?.PricingTab?.commonPricingData?.activityManagePricingId || 0);
            dispatch(loaderActions.end());
        }
        else {
            dispatch(loaderActions.end());
        }
    }
    //#endregion

    //#region dropdown options API
    const getactivitiesmanageoptions = async (ActivityManageId) => {
        let cityList = [];
        const activitiesmanageoptions = await getAllData("/master/v1/getactivitiesmanageoptions");

        if (activitiesmanageoptions?.status) {
            const supplierList = activitiesmanageoptions?.data?.supplierList;
            const collectionWiseCategory = activitiesmanageoptions?.data?.collectionWiseCategory?.map((obj) => {
                obj.label = obj?.Label;
                obj.value = obj?.Value;
                obj.CategoryList = JSON.parse(obj?.CategoryList)?.map((category) => {
                    category.label = category?.Label;
                    category.value = category?.Value;
                    return category;
                })
                return obj;
            });
            const activityList = activitiesmanageoptions?.data?.activityList?.map((obj) => {
                obj.CategoryIds = JSON.parse(obj?.CategoryIds);
                obj.StateList = JSON.parse(obj?.StateList) || [];
                return obj;
            })
            const stateList = activitiesmanageoptions?.data?.stateList;
            cityList = activitiesmanageoptions?.data?.cityList;
            const pickupDropList = activitiesmanageoptions?.data?.pickupDropList;
            const accessPointOtherList = activitiesmanageoptions?.data?.accessPointOtherList;
            const activityTypesOption = activitiesmanageoptions?.data?.activityTypesOption;

            const accessPointOtherPickupList = activitiesmanageoptions?.data?.accessPointOtherList?.map(({ DropPoint, ...rest }) => {
                rest.label = rest?.PickUpPoint;
                return rest;
            })
            const accessPointOtherDropList = activitiesmanageoptions?.data?.accessPointOtherList?.map(({ PickUpPoint, ...rest }) => {
                rest.label = rest?.DropPoint;
                return rest;
            })
            const pickupPointList = [...pickupDropList, ...accessPointOtherPickupList]?.map((obj) => {
                const newObj = {
                    ...obj,
                    PickupId: obj?.value,
                    value: `${obj?.label}${obj?.value}`
                }
                return newObj;
            })
            const dropPointList = [...pickupDropList, ...accessPointOtherDropList]?.map((obj) => {
                const newObj = {
                    ...obj,
                    DropId: obj?.value,
                    value: `${obj?.label}${obj?.value}`
                }
                return newObj;
            })

            const weekDayList = activitiesmanageoptions?.data?.weekDayList;
            const policyTypeList = [{ label: "Select", value: 0 }, ...activitiesmanageoptions?.data?.policyTypeList];
            const paxTypeList = [{ label: "Select", value: 0 }, ...activitiesmanageoptions?.data?.paxTypeList]
            const taxList = [{ label: "Select %", value: 0, TaxValue: null }, ...activitiesmanageoptions?.data?.taxList]

            const currentStatusList = [{ label: "Select", value: 0 }, ...activitiesmanageoptions?.data?.currentStatusList]

            setDropdownData({
                supplierList, collectionWiseCategory, activityList, stateList,
                cityList, accessPointOtherList, pickupPointList, dropPointList,
                activityTypesOption, weekDayList, policyTypeList, paxTypeList, taxList, currentStatusList
            });
        }
        else {
            setDropdownData({
                supplierList: [], collectionWiseCategory: [], activityList: [], stateList: [],
                cityList: [], accessPointOtherList: [], pickupPointList: [], dropPointList: [],
                weekDayList: [], policyTypeList: [], paxTypeList: [], taxList: [], currentStatusList: []
            });

        }

        setRetrieveData(ActivityManageId, cityList, activitiesmanageoptions?.data?.activityList);
    }
    //#endregion

    useEffect(() => {
        if (location?.state === null) {
            setEditDisabled(true);
            setDisabled(true);
            navigate("/Manageactivitylist");
            return;
        }
        setEditDisabled(location?.state?.editdisabled);
        setDisabled(location?.state?.disabled);
        const id = location?.state?.id || getActivityManageId() || 0;

        async function fetchData() {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                Promise.allSettled([
                    getactivitiesmanageoptions(id),
                ])
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: "SESSIONOUT", message: "Your Session Expired. Please Login Again!" })
            }
        }
        fetchData();
    }, [
        location?.state?.editdisabled
        || location?.state?.disabled
        || localStorage.getItem("ami")
    ]);
    //#endregion


    return (
        <div>
            {/* <div className="container-fluid mt-4 heading_color">
                <h3>Activity Master</h3>
            </div> */}
            <div className='container-fluid mt-3 tab_section px-0'>
                <ul className="nav nav-pills nav-justified mb-3 pt-3" id="pills-tab" role="tablist">
                    <li className="nav-item mx-lg-5 mx-md-1 mx-5 mt-1" role="presentation">
                        <button
                            className={`nav-link ${selectTab === 1 && "active"}`}
                            id="pills-basic-information-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-basic-information"
                            type="button" role="tab"
                            aria-controls="pills-basic-information"
                            aria-selected="true"
                            onClick={() => setSelectTab(1)}
                        >
                            <strong>Basic Information</strong>
                        </button>
                    </li>
                    <li className="nav-item mx-lg-5 mx-md-1 mx-5 mt-1" role="presentation" >
                        <button
                            className={`nav-link ${selectTab === 2 && "active"}`}
                            id="pills-variants-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-variants"
                            type="button" role="tab"
                            aria-controls="pills-variants"
                            aria-selected="false"
                            onClick={() => setSelectTab(2)}
                        >
                            <strong>Activity</strong>
                        </button>
                    </li>
                    <li className="nav-item mx-lg-5 mx-md-1 mx-5 mt-1" role="presentation">
                        <button
                            className={`nav-link ${selectTab === 3 && "active"}`}
                            id="pills-pricing-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-pricing"
                            type="button" role="tab"
                            aria-controls="pills-pricing"
                            aria-selected="false"
                            onClick={() => setSelectTab(3)}
                        >
                            <strong>Pricing</strong>
                        </button>
                    </li>
                    <li className="nav-item mx-lg-5 mx-md-1 mx-5 mt-1" role="presentation">
                        <button
                            className={`nav-link ${selectTab === 4 && "active"}`}
                            id="pills-inventory-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-inventory"
                            type="button" role="tab"
                            aria-controls="pills-inventory"
                            aria-selected="false"
                            onClick={() => setSelectTab(4)}
                        >
                            <strong>Inventory Availability</strong>
                        </button>
                    </li>
                </ul>
            </div>

            <div className="tab-content" id="pills-tabContent">
                <div className={`tab-pane fade show ${selectTab === 1 && "active"}`} id="pills-basic-information" role="tabpanel" aria-labelledby="pills-basic-information-tab">
                    {
                        selectTab === 1 &&
                        <ActivityBasicInfo
                            basicInfoTab={basicInfoTab}
                            setBasicInfoTab={setBasicInfoTab}
                            dropdownData={dropdownData}
                            editDisabled={editDisabled}
                            setEditDisabled={setEditDisabled}
                            disabled={disabled}
                            setDisabled={setDisabled}
                            setSelectTab={setSelectTab}
                        />
                    }
                </div>
                <div className={`tab-pane fade show ${selectTab === 2 && "active"}`} id="pills-variants" role="tabpanel" aria-labelledby="pills-variants-tab">
                    {
                        selectTab === 2 &&
                        <ActivityVariants
                            activityData={activityInfo}
                            setActivityInfo={setActivityInfo}
                            dropdownData={dropdownData}
                            editDisabled={editDisabled}
                            setEditDisabled={setEditDisabled}
                            disabled={disabled}
                            setDisabled={setDisabled}
                            setSelectTab={setSelectTab}
                        />
                    }
                </div>
                <div className={`tab-pane fade show ${selectTab === 3 && "active"}`} id="pills-pricing" role="tabpanel" aria-labelledby="pills-pricing-tab">
                    {
                        selectTab === 3 &&
                        <ActivityPricing
                            disabled={disabled}
                            PricingTab={PricingTab}
                            setPricingTab={setPricingTab}
                            ActivityName={ActivityName}
                            dropdownData={dropdownData}
                            editDisabled={editDisabled}
                            setEditDisabled={setEditDisabled}
                            ActivityManagePricingId={ActivityManagePricingId}
                            setActivityManagePricingId={setActivityManagePricingId}
                            ActivityBasicInfoId={ActivityBasicInfoId}
                        />
                    }
                </div>
                <div className={`tab-pane fade show ${selectTab === 4 && "active"}`} id="pills-inventory" role="tabpanel" aria-labelledby="pills-inventory-tab">
                    {
                        selectTab === 4 &&
                        <ActivityInventory
                            ActivityName={ActivityName}
                            ActivityBasicInfoId={ActivityBasicInfoId}
                            disabled={disabled}
                            dropdownData={dropdownData}
                        />
                    }
                </div>
            </div>

        </div>
    )
}

export default ManageActivityMaster
